import type { ILocationRequest, ILocationResponse, ILocationResponseV1 } from "@/types"

export class Location {
  public locationId?: number
  public googleId?: string
  public otherId?: string
  public name?: string
  public latitude?: number
  public longitude?: number
  public streetNumber?: string
  public streetAddress?: string
  public city?: string
  public state?: string
  public region?: string
  public zipCode?: string
  public country?: string
  public isPrivate?: boolean
  public formattedAddress?: string
  public displayAddress?: string
  public website?: string
  public pointOfInterest?: boolean = false
  public establishment?: boolean = false

  constructor(location: Partial<Location>) {
    this.locationId = location.locationId
    this.googleId = location.googleId
    this.otherId = location.otherId
    this.name = location.name
    this.latitude = location.latitude
    this.longitude = location.longitude
    this.streetNumber = location.streetNumber
    this.streetAddress = location.streetAddress
    this.city = location.city
    this.state = location.state
    this.region = location.region
    this.zipCode = location.zipCode
    this.country = location.country
    this.isPrivate = location.isPrivate
    this.formattedAddress = location.formattedAddress
    this.website = location.website
    this.pointOfInterest = location.pointOfInterest ?? false
    this.establishment = location.establishment ?? false

    this.displayAddress = (this.pointOfInterest || this.establishment) && location.name
      ? `${location.name}, ${location.formattedAddress}`
      : location.formattedAddress
  }

  public static fromResponseV1(response: ILocationResponseV1) {
    return new Location({
      locationId: response.locationId,
      googleId: response.googleId,
      otherId: response.otherId,
      name: response.name,
      latitude: response.latitude,
      longitude: response.longitude,
      streetNumber: response.streetNumber,
      streetAddress: response.streetAddress,
      city: response.city,
      state: response.state,
      region: response.region,
      zipCode: response.zipCode,
      country: response.country,
      isPrivate: response.isPrivate,
      formattedAddress: response.formattedAddress,
      website: response.website,
      pointOfInterest: response.pointOfInterest ?? false,
      establishment: response.establishment ?? false,
    })
  }

  public static fromResponse(response: ILocationResponse) {
    return new Location({
      locationId: response.LocationID,
      googleId: response.GoogleID,
      otherId: response.OtherID,
      name: response.Name,
      latitude: response.Latitude,
      longitude: response.Longitude,
      streetNumber: response.StreetNumber,
      streetAddress: response.StreetAddress,
      city: response.City,
      state: response.State,
      region: response.Region,
      zipCode: response.ZipCode,
      country: response.Country,
      isPrivate: response.IsPrivate,
      formattedAddress: response.FormattedAddress,
      website: response.Website,
      pointOfInterest: response.PointOfInterest ?? false,
      establishment: response.Establishment ?? false,
    })
  }

  public static toRequest(location: Partial<Location>): ILocationRequest {
    return {
      LocationID: location.locationId,
      GoogleID: location.googleId,
      OtherID: location.otherId,
      Name: location.name,
      Latitude: location.latitude,
      Longitude: location.longitude,
      StreetNumber: location.streetNumber,
      StreetAddress: location.streetAddress,
      City: location.city,
      State: location.state,
      Region: location.region,
      ZipCode: location.zipCode,
      Country: location.country,
      IsPrivate: location.isPrivate,
      FormattedAddress: location.formattedAddress,
      Website: location.website,
      PointOfInterest: location.pointOfInterest ?? false,
      Establishment: location.establishment ?? false,
    }
  }
}
